import QuoteDataCart from 'au-js-sdk/lib/api/models/magento/quote/QuoteDataCart';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { fetchCartRequest } from '../../store/cart/actions';
import { cartSelector } from '../../store/cart/selectors';
import { GlobalState } from '../constants';
import { objIsEmpty } from 'helpers/objects';

interface WithCartProps {
  cart: QuoteDataCart;
  fetchCartRequest: () => void;
}

//TODO: Figure out types here
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function withCart<T>(WrappedComponent: React.ComponentType<T & WithCartProps>) {
  const Wrapper = (props: T & WithCartProps) => {
    const cartIsEmpty = objIsEmpty(props.cart);
    useEffect(() => {
      if (cartIsEmpty) {
        props.fetchCartRequest();
      }
    }, [cartIsEmpty, props]);

    return React.createElement(WrappedComponent, props);
  };

  const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchCartRequest: () => dispatch(fetchCartRequest())
  });

  const mapStateToProps = (state: GlobalState) => ({
    cart: cartSelector(state)
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
    // TODO: This type is jacked up, please fix if you're in this file
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
  )(Wrapper);
}
